import { NgModule } from '@angular/core';
import { TranslateItPipe } from './translate-it';
import { TranslationPipe } from './translation-pipe.pipe';

@NgModule({
  declarations: [TranslateItPipe, TranslationPipe],
  exports: [TranslateItPipe, TranslationPipe],
})
export class TranslateItModule {}
